<template>
    <div>
        <div class="header">
            <img v-if="inInspection" id="enterprise-logo" :src="enterpriseLogoSrc" @click="goToHomePage" width="90px"/>
            <p v-if="inInspection" class="text-center">
                <span v-if="$store.state.inspectionData.numberPlate">
                    {{ $store.state.inspectionData.numberPlate }}
                </span>
                <span v-if="$store.state.inspectionData.quizType">
                    - {{ $store.state.inspectionData.quizType }}
                </span>
                <span v-if="$store.state.inspectionData.operation">
                    - {{ $store.state.inspectionData.operation.nome }}
                </span>
            </p>
            <img v-else src="@/assets/inovaclickPngs/vexBranco.png" alt="" width="100px" @click="goToHomePage" />
            <DropDownMenu />
        </div>
    </div>
</template>

<script>
import DropDownMenu from "@/components/DropDownMenu.vue";
import Swal from "sweetalert2";

export default {
    components: {
        DropDownMenu,
    },
    data: function() {
        return {
            inInspection: null,
            enterpriseLogoSrc: null
        };
    },
    methods: {
        goToHomePage() {
            if(this.inInspection) {
                Swal.fire({
                    title: "Ir para página Inicial?",
                    text: "Sua vistoria será cancelada!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#3085d6",
                    cancelButtonText: "Continuar Vistoria",
                    confirmButtonText: "Ir para página inicial",
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$router.push({ path: "/home" });
                    }
                });
            } else {
                this.$router.push({ path: "/home" });
            }
        },
        testInInspection(path) {
            return /^\/inspection(\/?$|\/.+)/.test(path);
        }
    },
    mounted: function () {
        this.enterpriseLogoSrc = localStorage.getItem("enterpriseLogo");
        this.inInspection = this.testInInspection(this.$router.currentRoute.path);
    },
    watch: {
        $route (to, from) {
            this.inInspection = this.testInInspection(to.path);
        }
    }
};
</script>

<style lang="scss" scoped>
.header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #343a40;
    height: 60px;
    
    p {
        margin: 5px 0px;
        font-size: 13px;
        color: white;
    }

    .dropdown {
        padding: 10px;
    }

    img, .dropdown {
        margin: 10px;
    }

    img {
        cursor: pointer;
    }
}

</style>
